import {Component, Inject, NgZone, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {environment} from '../environments/environment';
import {AppConfigService} from "./core/services/app-config.service";
import {LocalLanguageService} from "./core/services/local-language.service";
import {Title} from "@angular/platform-browser";
import {RouteHistoryService} from "./core/services/route-history.service";
import {DOCUMENT} from "@angular/common";
import {LoggingService} from './log/logging.service';


@Component({
  selector: 'body',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {

  constructor(public router: Router,
              public translateService: TranslateService,
              public zone: NgZone,
              private localLanguageService: LocalLanguageService,
              private appConfigService: AppConfigService,
              private title: Title,
              private translate: TranslateService,
              private routeHistoryService: RouteHistoryService,
              private loggingService: LoggingService,
              @Inject(DOCUMENT) private _document: any) {
    this.appConfigService.setKanton(environment.kanton);
    this.localLanguageService.setUp();
    this.loggingService.initializeLogger();
    this.title.setTitle(this.translate.instant('layouts.page.title'));
    this.routeHistoryService.initializeRouterHistoryService();
  }

  ngOnInit(): void {
    this._document.documentElement.lang = this.translate.currentLang;
    this.translate.onLangChange.subscribe(lang => {
      this._document.documentElement.lang = lang.lang;
    });
  }
}
